import React from 'react'
import { ImageSettings } from './ImageSettings'

import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'

import { WImage } from '@next-nx/shared-ui/atoms'

export const defaultProps = {
  src: 'https://via.placeholder.com/800x600.png',
  alt: 'Image',
  align: 'left',
  width: 0,
  height: 0,
}

export const dynamicProps = ['src']

const RenderedImage = React.memo(({ src, alt, width, height }) => {
  return (
    <WImage
      src={src}
      title={alt}
      alt={alt}
      maxWidth={width}
      maxHeight={height}
      layout={!width || !height ? 'responsive' : 'intrinsic'}
    />
  )
})

export const Image = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }
    const { src, alt, align, width, height } = blockProps

    const _ = props.renderValue

    const classNames = `
      block-image 
      ${props.className}
      block-image-${align}
    `

    return (
      <div // img non supporta :after
        ref={(ref) => props.retRef(ref)}
        className={classNames}
      >
        <RenderedImage
          key={src}
          src={_(src)}
          title={alt}
          alt={alt}
          width={width || 0}
          height={height || 0}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

Image.craft = withCraft({
  name: 'Image',
  defaultProps: defaultProps,
  settings: ImageSettings,
})
